/** Plain text only, using columns present in the returned row. No lookup or expression execution. */
export function formatRecordLabelTemplate(
  template: string,
  row: Record<string, unknown>,
): string {
  return template
    .replace(/\{([^{}]+)\}/g, (_match, key: string) => {
      if (!Object.prototype.hasOwnProperty.call(row, key)) return "";
      const value = row[key];
      return typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
        ? String(value)
        : "";
    })
    .replace(/[ \t]+/g, " ")
    .trim();
}
